import { Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { EntDirectoryInfoName } from "../../../../../models/directoryInfoName";
import { DraggableModal } from "../../../../../components/DraggableModal";

enum FormField {
  nameKy,
  nameRu
}

interface IProps {
  show: boolean;
  typesOfPesticides: EntDirectoryInfoName;
  onHide: () => void;
  onSubmit: (pos: EntDirectoryInfoName) => Promise<boolean>;
}

export const AddTypesOfPesticides = (props: IProps) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
	if (props.show) setFieldsFromEntity();
  }, [props.show]);

  const setFieldsFromEntity = (): void => {
	form.setFields([
	  { name: FormField.nameKy, value: props.typesOfPesticides.nameKy },
	  { name: FormField.nameRu, value: props.typesOfPesticides.nameRu },
	]);
  }

  const setEntityFromFields = (): EntDirectoryInfoName => {
	let typesOfPesticides = _.cloneDeep(props.typesOfPesticides);
	typesOfPesticides.nameKy = form.getFieldValue(FormField.nameKy);
	typesOfPesticides.nameRu = form.getFieldValue(FormField.nameRu);
	return typesOfPesticides;
  }

  const handleSubmit = async () => {
	setLoading(true);
	try {
	  await form.validateFields();
	  const data = setEntityFromFields();
	  const result = await props.onSubmit(data);
	  if (result) props.onHide();
	} finally {
	  setLoading(false);
	}
  }

  return (
	<>
	  <DraggableModal
		title={props.typesOfPesticides.id === 0 ? t('handbooks.types_of_pesticides.add_types_of_pesticides') : t('handbooks.types_of_pesticides.edit_types_of_pesticides')}
		visible={props.show}
		onCancel={props.onHide}
		onSubmit={handleSubmit}
		submitLoading={loading}
	  >
		<Form
		  initialValues={{ remember: true }}
		  autoComplete="off"
		  layout="vertical"
		  form={form}
		>
		  <Form.Item
			label={ t('general.nameKy') }
			name={FormField.nameKy}
			rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
		  >
			<Input autoComplete="off" />
		  </Form.Item>
		  <Form.Item
			label={ t('general.nameRu') }
			name={FormField.nameRu}
			rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
		  >
			<Input autoComplete="off" />
		  </Form.Item></Form>
	  </DraggableModal>
	</>
  )
}









